// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"61b37b76","788":"61597516"}[chunkId] + ".chunk.js";
};